import { jsPDF } from "jspdf";
import { createEvent } from "ics";
import { getFullDateString, getFullHourAndMinute } from "../services/formatters";
import { useSession } from "./useSession";

export const useRecapIcons = () => {
  const { read, getAppointmentPayload } = useSession();

  const getApptoUserProperty = (prop) => {
    const appto = getAppointmentPayload();
    return appto[prop];
  };
  const getSubRawProperty = (prop) => {
    const sub = read("filialeScelta");
    try {
      return sub[prop];
    } catch (error) {
      return "";
    }
  };

  const isIOSSafari = () => {
    const ua = window.navigator.userAgent;
    const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    const webkit = !!ua.match(/WebKit/i);

    return iOS && webkit && !ua.match(/CriOS/i);
  };

  const onPrintClick = () => {
    const nome = `${getApptoUserProperty("nome")} ${getApptoUserProperty("cognome")}`;
    const telefono = getApptoUserProperty("cellulare");
    const filiale = getSubRawProperty("nomeFiliale");
    const indirizzo = getSubRawProperty("indirizzo");
    const data = getFullDateString(read("dataScelta").data);
    const ora = getFullHourAndMinute(read("orarioScelto").hour, read("orarioScelto").minute);
    const prodotto = Math.floor(Math.random() * 2);
    let print_body = `
      <!doctype html>
      <html>
          <head>
              <meta charset="utf-8">
              <title>Il tuo appuntamento ${prodotto != 3 ? "in filiale" : "in agenzia"} Compass</title>
              <style>
                  body { text-align: center; font-family: arial; }
                  #logo { margin-bottom: 40px 0 70px; }
              </style>
          </head>
          <body>
              <div id="logo">
                  <img src="https://www.compass.it/application/themes/compass/assets/img/loghi/logo-compass-banca.png" />
              </div>
              <br/><br/>
              <h2>TI ASPETTIAMO IN ${prodotto != 3 ? "FILIALE" : "AGENZIA"}</h2>
              <h5>Ecco il riepilogo del tuo appuntamento</h5>
              <div class="separatore"></div>
              <div class="entry">${nome}</div>
              <div class="entry">${telefono}</div>
              <br/>
              <div class="entry">${filiale}</div>
              <div class="entry">${indirizzo}</div>
              <br/>
              <div class="entry">${data}</div>
              ${ora ? `<div class="entry">${ora}</div>` : ""}
              <br/><br/>
              <strong>Documenti necessari</strong><br/>
              <br/>
              Documento di riconoscimento in corso di validit&agrave;<br/>
              <br/>
              Carta Regionale/Nazionale dei Servizi (Tessera Sanitaria)<br/>
              <br/>
              Copia del giustificativo di reddito in possesso al richiedente
              <script>setTimeout('window.print();',1000);</script>
          <body>
      </html>
  `;
    const wnd = window.open("about:blank", "", "_blank");
    if (wnd) wnd.document.write(print_body);
  };

  const onDownloadPdfClick = () => {
    const nome_filiale = getSubRawProperty("nomeFiliale");
    const indirizzo_filiale = getSubRawProperty("indirizzo");
    const data_str = getFullDateString(read("dataScelta").data);
    const ora = getFullHourAndMinute(read("orarioScelto").hour, read("orarioScelto").minute);
    const prodotto = Math.floor(Math.random() * 2);

    var doc = new jsPDF();
    doc.setFontSize(22);
    doc.setTextColor(204, 0, 0);
    doc.text("Appuntamento in Compass", 30, 30);
    doc.setFontSize(15);
    doc.setTextColor(51, 51, 51);
    doc.text(`Ti aspettiamo in ${prodotto != 3 ? "filiale" : "agenzia"} ` + data_str + `${ora ? ` alle ${ora}` : ""}`, 30, 55);
    //doc.addImage(imgData, 'JPEG', 30, 70, 530, 300); //350
    doc.setFontSize(15);
    doc.setTextColor(204, 0, 0);
    doc.text(nome_filiale, 30, 65);
    doc.setTextColor(51, 51, 51);
    doc.text(indirizzo_filiale, 30, 75);
    doc.setTextColor(204, 0, 0);
    doc.text("Documenti necessari", 30, 105);
    doc.setTextColor(51, 51, 51);
    doc.text("Documento di riconoscimento in corso di validità", 30, 115);
    doc.text("Carta Regionale/Nazionale dei Servizi (Tessera Sanitaria)", 30, 125);
    doc.text("Copia del giustificativo di reddito in possesso al richiedente", 30, 135);
    doc.output("dataurlnewwindow");
  };

  const onSaveToICalClick = () => {
    const nome_filiale = getSubRawProperty("nomeFiliale");
    const indirizzo_filiale = getSubRawProperty("indirizzo");
    const date = new Date(getApptoUserProperty("data"));
    const coords = getSubRawProperty("coordinate");

    const event = {
      start: [date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes()],
      duration: { hours: 1, minutes: 0 },
      productId: "Compass Banca",
      title: nome_filiale,
      description: indirizzo_filiale,
      location: indirizzo_filiale,
      geo: { lat: coords.lat, lon: coords.lng },
      status: "CONFIRMED",
    };

    createEvent(event, (error, value) => {
      if (error) {
        console.error(error);
        return;
      }

      if (isIOSSafari()) {
        window.open("data:text/calendar;charset=utf8," + escape(value));
      } else {
        const blob = new Blob([value], {
          type: "text/calendar;charset=utf-8",
        });
        const linkEl = document.createElement("a");
        linkEl.href = window.URL.createObjectURL(blob);
        linkEl.setAttribute("download", "Appuntamento");
        document.body.appendChild(linkEl);
        linkEl.click();
        document.body.removeChild(linkEl);
      }
    });
  };

  const showMap = (city, address, coords) => {
    window.open("https://www.google.it/maps/place/" + address + "," + city + "/@" + coords.lat + "," + coords.lng + ",17z", "_blank");
  };
  const onShowMapClick = () => {
    showMap(getSubRawProperty("citta"), getSubRawProperty("indirizzo"), getSubRawProperty("coordinate"));
  };

  const showRoadIndications = (daddr) => {
    let saddr = "41.90278349999999,12.496365500000024";
    const location = window.navigator && window.navigator.geolocation;
    if (location) {
      location.getCurrentPosition((position) => {
        saddr = position.coords.latitude + "," + position.coords.longitude;
        window.open("https://www.google.it/maps?saddr=" + saddr + "&daddr=" + daddr + "_blank");
      });
    } else {
      window.open("https://www.google.it/maps?saddr=" + saddr + "&daddr=" + daddr + "_blank");
    }
  };
  const onGetDirectionsClick = () => {
    showRoadIndications(`Compass ${getSubRawProperty("indirizzo")}`, getSubRawProperty("coordinate"));
  };

  return {
    onShowMapClick,
    onGetDirectionsClick,
    onPrintClick,
    onDownloadPdfClick,
    onSaveToICalClick,
  };
};
